// Centralised axios instance for all backend calls
// Auto-attaches the Firebase ID token from the currently signed-in user
import axios from 'axios';
import { auth } from '../firebase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public client (no auth) — for trip + participants public reads
export const publicApi = axios.create({ baseURL: API_BASE });
